import React from 'react';

function PopupFormShareClassParticipation() {
  return <div className='col-md-9' />;
}

PopupFormShareClassParticipation.propTypes = {
};

export default PopupFormShareClassParticipation;
